import { text } from './content';

export const EMOTE_PRESETS = ['wave', 'celebrate', 'heart'] as const;
export type EmotePreset = (typeof EMOTE_PRESETS)[number];
export type SceneEmote = { preset: EmotePreset; until: number };
export const EMOTE_DURATION_MS = 3000;
export const EMOTE_COOLDOWN_MS = 3000;
export const emoteCopy = {
  wave: { emoji: '👋', label: text('Wave', '挥手', '揮手', 'Saludar') },
  celebrate: { emoji: '🎉', label: text('Celebrate', '庆祝', '慶祝', 'Celebrar') },
  heart: { emoji: '❤️', label: text('Send a heart', '比心', '比心', 'Enviar un corazón') },
} as const;
export function activeEmote(emote: SceneEmote | undefined, serverNow: number): EmotePreset | undefined {
  return emote &&
    EMOTE_PRESETS.includes(emote.preset) &&
    Number.isFinite(emote.until) &&
    emote.until > serverNow
    ? emote.preset
    : undefined;
}
